import React from 'react';
import { InstagramIcon } from 'lucide-react';
export function TopBar() {
  return <div className="bg-volcanic text-ivory/90 text-[9px] sm:text-[10px] tracking-[0.15em] px-4 sm:px-6 py-2.5 flex justify-between items-center uppercase font-light" data-id="element-283" data-mp="2335avgbd225u">
      <div className="truncate flex-1" data-id="element-284" data-mp="1y5wr5bakdq2h">
        <a href="mailto:yes.picnic.tenerife@gmail.com" className="hidden md:inline hover:text-terracotta transition-colors duration-300" data-id="element-285" data-mp="1t58zqoifb77q">
          yes.picnic.tenerife@gmail.com
        </a>
        <span className="hidden md:inline" data-id="element-286" data-mp="2lug07t1fu6vm"> · </span>
        <a href="tel:+34689621262" className="hover:text-terracotta transition-colors duration-300 whitespace-nowrap" data-id="element-287" data-mp="2lvr55w6mdkob">
          +34 689 621 262
        </a>
      </div>
      <a href="https://www.instagram.com/yes.picnic.tenerife/" target="_blank" rel="noopener noreferrer" aria-label="Instagram @yes.picnic.tenerife" className="flex items-center gap-2 hover:text-terracotta transition-colors duration-300 flex-shrink-0" data-id="element-288" data-mp="2c1qz9s3ikbej">
        <InstagramIcon size={12} strokeWidth={1.5} data-id="element-289" data-mp="27lq0dsl2hnf" />
        <span className="hidden xs:inline" data-id="element-290" data-mp="65jd9b2smto6">@yes.picnic.tenerife</span>
      </a>
    </div>;
}